import { createFileRoute } from "@tanstack/react-router";

import { DbArticleView } from "@/components/site/DbArticleView";
import { dbArticleLabels, loadDbArticle } from "@/lib/db-article-loader";
import { ARTICLE_TYPE_SECTIONS } from "@/lib/articles.shared";
import { pageLinks } from "@/lib/locale-alternates";
import { breadcrumb, documentArticle, graph, webPage, faqPage } from "@/lib/schema";
import { documentDescription, documentKeywords, documentTitle, socialMeta } from "@/lib/seo";

const TYPE = "whitepaper";
const LOCALE = "tr";
const SECTION = ARTICLE_TYPE_SECTIONS[TYPE][LOCALE];

export const Route = createFileRoute("/tr/teknik-raporlar_/$slug")({
  loader: ({ params }) =>
    loadDbArticle(LOCALE, TYPE, params.slug, { label: "OXORY ile iletişime geçin", to: "/tr/iletisim" }),
  head: ({ params, loaderData }) => {
    const item = loaderData?.item;
    if (!item) {
      return { meta: [{ title: "Doküman bulunamadı | OXORY" }, { name: "robots", content: "noindex" }] };
    }
    const path = `${SECTION.base}/${params.slug}`;
    const seoTitle = documentTitle(item.metaTitle, "whitepaper", "tr");
    const seoDescription = documentDescription(item.metaDescription, "whitepaper", "tr");
    const pdfHref = item.pdfUrl ?? `/api/public/article-pdf?locale=tr&slug=${params.slug}`;
    return {
      meta: [
        { title: seoTitle },
        { name: "description", content: seoDescription },
        ...socialMeta({
          locale: "tr_TR",
          title: seoTitle,
          description: seoDescription,
          path,
          type: "article",
          socialTitle: item.title,
          imageAlt: `OXORY teknik doküman — ${item.title}`,
          articleId: item.articleIndex,
        }),
        { property: "article:published_time", content: item.published },
        { property: "article:modified_time", content: item.updated },
      ],
      links: [
        ...pageLinks(path),
        { rel: "alternate", type: "application/pdf", href: pdfHref, title: `${item.title} (PDF)` },
      ],
      scripts: [
        graph(
          webPage({ path, name: seoTitle, description: seoDescription, inLanguage: LOCALE }),
          documentArticle({
            path,
            kind: "whitepaper",
            headline: item.title,
            description: item.metaDescription,
            published: item.published,
            modified: item.updated,
            inLanguage: LOCALE,
            keywords: documentKeywords(item.keywords, "whitepaper", "tr"),
            articleId: item.articleIndex,
            pdf: pdfHref,
          }),
          breadcrumb([
            { name: "Ana Sayfa", path: "/tr" },
            { name: SECTION.name, path: SECTION.base },
            { name: item.title, path },
          ]),
          ...(import.meta.env.SSR && item.faq.length ? [faqPage(item.faq)] : []),
        ),
      ],
    };
  },
  component: TrWhitepaperDetailPage,
});

function TrWhitepaperDetailPage() {
  const { item, related } = Route.useLoaderData();
  return <DbArticleView item={item} related={related} labels={dbArticleLabels(LOCALE, SECTION)} type={TYPE} locale={LOCALE} />;
}
